__turbopack_context__.v({
  "details": "uGqc2W_details",
  "imageWrapper": "uGqc2W_imageWrapper",
  "mobileContent": "uGqc2W_mobileContent",
  "right": "uGqc2W_right",
  "row": "uGqc2W_row",
  "searchProductCardWrapper": "uGqc2W_searchProductCardWrapper",
  "tabletAndWebContent": "uGqc2W_tabletAndWebContent",
});
